import { Controller } from "@hotwired/stimulus"

// Shows the currency symbol of the country picked in the form, read from the selected option's data-country, and the
// default symbol while the option names no country priced in.
export default class extends Controller {
  static values = {
    defaultSymbol: String,
    symbols: Object
  }

  static targets = ["country", "symbol"]

  update() {
    this.symbolTargets.forEach(symbol => {
      this.#show(symbol)
    })
  }

  // A price field added to the form later, such as a new option's, shows the symbol of the country picked by then.
  symbolTargetConnected(symbol) {
    this.#show(symbol)
  }

  get #symbol() {
    return this.symbolsValue[this.countryTarget.selectedOptions[0]?.dataset.country] ?? this.defaultSymbolValue
  }

  #show(symbol) {
    symbol.textContent = this.#symbol
  }
}
